import { useState } from "react";
import {
  MobileDateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import ClearIcon from "@mui/icons-material/Clear";

import {
  Drawer,
  Box,
  Typography,
  IconButton,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useMedia } from "../context/MediaContext";
import { useTheme } from "@mui/material";
const LogsFilters: React.FC<{
  setFilters: React.Dispatch<
    React.SetStateAction<{
      ts_to: string | null;
      ts_from: string | null;
      provider: string | null;
      status: number[];
      url_like: string | null;
    }>
  >;
  filters: {
    ts_to: string | null;
    ts_from: string | null;
    provider: string | null;
    status: number[];
    url_like: string | null;
  };
  setOpenDrawer: React.Dispatch<React.SetStateAction<boolean>>;
  openDrawer: boolean;
  requestLogs: (idValue?: string | undefined) => Promise<void>;
  providers: any;
  logType: string;
  idValue: string;
}> = ({
  setFilters,
  filters,
  openDrawer,
  setOpenDrawer,
  requestLogs,
  providers,
  logType,
  idValue,
}) => {
  const darkTheme = useTheme();
  const { isMobile600 } = useMedia();
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ru">
      {providers ? (
        <Drawer
          anchor="right"
          open={openDrawer}
          onClose={() => setOpenDrawer(false)}
          hideBackdrop
          ModalProps={{
            disableEnforceFocus: true,
            disableAutoFocus: true,
            disableRestoreFocus: true,
            keepMounted: true,
          }}
          sx={{
            pointerEvents: "none",
            "& .MuiDrawer-paper": {
              pointerEvents: "auto",

              width: "30vw",
              maxWidth: 480,
              minWidth: 360,

              background:
                darkTheme.palette.mode === "light"
                  ? "rgba(255, 255, 255, 0.57)"
                  : "transparent",
              backdropFilter: "blur(25px)",
              borderLeft: "1px solid rgba(255,255,255,0.08)",

              padding: "24px",
            },
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
            pb={2}
            sx={{
              borderBottom: "1px solid rgba(255,255,255,0.08)",
            }}
          >
            <Typography fontSize={20} fontWeight="bold">
              Фильтры
            </Typography>

            <IconButton
              onClick={() => setOpenDrawer(false)}
              sx={{
                background: "rgba(255,255,255,0.08)",
                "&:hover": {
                  background: "rgba(255,255,255,0.15)",
                },
              }}
            >
              <ClearIcon />
            </IconButton>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "45px",
              mt: 3,
            }}
          >
            <FormControl>
              <InputLabel
                shrink={true}
                sx={{
                  fontSize: "20px",
                  marginTop: "20px",
                  transform: "translateY(-55px)",
                }}
              >
                Дата от
              </InputLabel>
              <MobileDateTimePicker
                value={filters.ts_from ? dayjs(filters.ts_from) : null}
                onChange={(newValue) =>
                  setFilters((prev) => ({
                    ...prev,
                    ts_from: newValue
                      ? dayjs(newValue).format("YYYY-MM-DDTHH:mm:ss.SSS")
                      : null,
                  }))
                }
                slotProps={{
                  textField: {
                    sx: { width: "100%" },
                  },
                }}
              />
            </FormControl>
            <FormControl>
              <InputLabel
                shrink={true}
                sx={{
                  fontSize: "20px",
                  marginTop: "20px",
                  transform: "translateY(-55px)",
                }}
              >
                Дата по
              </InputLabel>
              <MobileDateTimePicker
                value={filters.ts_to ? dayjs(filters.ts_to) : null}
                onChange={(newValue) =>
                  setFilters((prev) => ({
                    ...prev,
                    ts_to: newValue
                      ? dayjs(newValue).format("YYYY-MM-DDTHH:mm:ss.SSS")
                      : null,
                  }))
                }
                slotProps={{
                  textField: {
                    sx: { width: "100%" },
                  },
                }}
              />
            </FormControl>
            {logType === "outgoing" ? (
              <FormControl fullWidth>
                <InputLabel
                  shrink={true}
                  sx={{
                    fontSize: "20px",
                    marginTop: "20px",
                    transform: "translateY(-55px)",
                  }}
                >
                  Провайдер
                </InputLabel>
                <Select
                  value={filters.provider}
                  onChange={(event) => {
                    const value = event.target.value as string | null;
                    console.log(value);
                    setFilters((prev) => ({
                      ...prev,
                      provider: value,
                    }));
                  }}
                >
                  {providers.map((el: any) => (
                    <MenuItem key={el.id} value={el.name}>
                      {el.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : null}
            <FormControl>
              <InputLabel
                shrink={true}
                sx={{
                  fontSize: "20px",
                  marginTop: "20px",
                  transform: "translateY(-55px)",
                }}
              >
                URL Путь
              </InputLabel>
              <TextField
                value={filters.url_like ?? ""}
                onChange={(event) => {
                  const value = event.target.value;
                  setFilters((prev) => ({
                    ...prev,
                    url_like: value,
                  }));
                }}
              />
            </FormControl>
            <FormControl sx={{ width: "100%" }}>
              <InputLabel
                shrink={true}
                sx={{
                  fontSize: isMobile600 ? "18px" : "20px",
                  transform: "translateY(-30px)",
                }}
                id="demo-multiple-chip-label"
              >
                Выберите статус
              </InputLabel>
              <Select
                sx={{
                  minHeight: "72px",
                }}
                multiple
                value={filters?.status}
                onChange={(event) => {
                  const value = event.target.value as number[];
                  setFilters((prev) => ({
                    ...prev,
                    status: value,
                  }));
                }}
                renderValue={(selected) => (
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 1,
                    }}
                  >
                    {selected?.map((value: number) => (
                      <Box
                        key={value}
                        sx={{
                          px: 2,
                          py: 1,
                          borderRadius: "16px",
                          bgcolor: "primary.main",
                          color: "white",
                          fontWeight: "bold",
                          cursor: "pointer",
                          "&:hover": { opacity: 0.8 },
                        }}
                      >
                        {value}
                      </Box>
                    ))}
                  </Box>
                )}
              >
                {[200, 201, 409, 401, 400, 404, 500].map((status) => (
                  <MenuItem
                    sx={{
                      backgroundColor: filters?.status?.includes(status)
                        ? "rgba(13, 190, 221, 0.2)"
                        : "transparent",
                      "&.Mui-selected": {
                        backgroundColor: darkTheme.palette.primary.main,
                        "&:hover": {
                          backgroundColor: darkTheme.palette.primary.main,
                        },
                      },
                    }}
                    value={status}
                    key={status}
                  >
                    {status}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "15px",
              mt: "auto",
            }}
          >
            <Button
              variant="contained"
              onClick={() => requestLogs(idValue)}
              disabled={
                !filters.ts_from &&
                !filters.ts_to &&
                !filters.provider &&
                !filters.url_like &&
                filters.status.length === 0
              }
              size={isMobile600 ? "medium" : "small"}
            >
              Применить фильтры
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setFilters({
                  ts_from: null,
                  ts_to: null,
                  provider: null,
                  status: [],
                  url_like: null,
                });
              }}
            >
              Очистить фильтры
            </Button>
          </Box>
        </Drawer>
      ) : null}
    </LocalizationProvider>
  );
};
export default LogsFilters;
